// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"defa95da","703":"ecd07b8f"}[chunkId] + ".chunk.js";
};